import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AccordionComponentModule } from '@src/app/components/accordion/accordion.component.module.js'
import { ButtonComponentModule } from '@src/app/components/button/button.component.module.js'
import { MeasuringDeviceCardComponent } from '@src/app/components/measuring-device-card/measuring-device-card.component.js'
import { DoYouOwnDeviceComponent } from '@src/app/components/modals/do-you-own-device/do-you-own-device.component.js'
import { OuraEntranceComponent } from '@src/app/components/oura-entrance/oura-entrance.component.js'
import { VerifiedEmailBannerComponent } from '@src/app/components/verified-email-banner/verified-email-banner.component.js'
import { DiscountBannerComponent } from '@src/app/discount-banner/discount-banner.component.js'
import { SharedModule } from '@src/app/shared/shared.module.js'
import { MeasuringDeviceCardRevampedComponent } from '../../../ab-411/measuring-device-card-revamped/measuring-device-card-revamped.component'
import { MeasuringDevicePage } from './measuring-device.page.component.js'

const ROUTES: Routes = [
  {
    path: '',
    component: MeasuringDevicePage,
  },
]

@NgModule({
  declarations: [MeasuringDevicePage, DoYouOwnDeviceComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ROUTES),
    ButtonComponentModule,
    MeasuringDeviceCardComponent,
    AccordionComponentModule,
    VerifiedEmailBannerComponent,
    DiscountBannerComponent,
    OuraEntranceComponent,
    MeasuringDeviceCardRevampedComponent,
  ],
  exports: [],
  providers: [],
})
export class MeasuringDevicePageModule {}
